import { requestJson } from "../api/apiClient";

const BASE = "/api/admin/weather/scheduler";

export async function fetchWeatherSchedulerJobs() {
  return requestJson(`${BASE}/jobs`);
}

export async function fetchWeatherSchedulerJob(jobKey) {
  return requestJson(`${BASE}/jobs/${encodeURIComponent(jobKey)}`);
}

export async function runWeatherSchedulerJob(jobKey, body = {}) {
  return requestJson(`${BASE}/jobs/${encodeURIComponent(jobKey)}/run`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function patchWeatherSchedulerJob(jobKey, body) {
  return requestJson(`${BASE}/jobs/${encodeURIComponent(jobKey)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export async function runDueWeatherSchedulerJobs(body = {}) {
  return requestJson(`${BASE}/run-due`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
